/* istanbul ignore file */
import React, { Suspense, useEffect } from 'react';
import { Loader } from '@express-labs/raven-ui';
import { useLazyQuery } from '@apollo/client';
import GET_CONTENT from './queries/getContent';
import { GetContentQuery, GetContentQueryVariables } from '../graphql/graphql';
import { ChooInception } from './ChooInception';

const ErrorComponent = React.lazy(() => import('./ErrorComponent'));

export type ChooChooProps = {
  value: string;
  mode?: string;
  contentType?: string;
};

function ChooChoo({ value, mode, contentType }: ChooChooProps) {
  const [getChooChoo, { data, error }] = useLazyQuery<
    GetContentQuery,
    GetContentQueryVariables
  >(GET_CONTENT);

  useEffect(() => {
    getChooChoo({
      variables: {
        payload: {
          attribute: { key: mode, value },
          contentType: contentType,
        },
      },
    });
  }, [value, mode, contentType]);

  if (error) {
    console.error(`Choo-Choo ran out of steam: ${error}`);
    if (contentType === 'global_banner') {
      return null;
    }

    return (
      <div data-testid="error">
        <ErrorComponent />
      </div>
    );
  }
  if (data?.getContent) {
    return (
      <Suspense fallback={<Loader display="overlay" size="medium" />}>
        <ChooInception node={data.getContent.entries} />
      </Suspense>
    );
  }

  return (
    <div data-testid="loading">
      <Loader size="mini" />
    </div>
  );
}

export default React.memo(ChooChoo);
